// @flow
import React, { Component } from 'react';
import {
  TextArea, Checkbox, Radio, RadioGroup,
} from 'informed';
import NumericText from '../../../NumericText.jsx';

import { PrimaryText, SecondaryText } from '../../../Typography.jsx';
import ContentBox from '../../../ContentBox.jsx';
import { Button } from '../../../Buttons.jsx';

import styles from '../../../../styles/patientPages/progressNote/progressNote.scss';

type Props = {
  initSensory: Object,
  resetPupilsRadios: Function,
}

class EditSensory extends Component<Props> {
  render() {
    const sensory = this.props.initSensory || {};
    return (
      <ContentBox title='Sensory'>
        <div className={styles.col}>
          <PrimaryText>Vision Assessment:</PrimaryText><br />
          <div className={styles.section}>
            <Checkbox field='sensory.noVisionProblems' initialValue={sensory.noVisionProblems} />No major vision problems noted
          </div>
          <div className={styles.section}>
            <SecondaryText>Mark all that apply:</SecondaryText><br />
            <Checkbox field='sensory.visionWorsening' initialValue={sensory.visionWorsening} />Vision problems worsening<br />
            <Checkbox field='sensory.difficultyAtNight' initialValue={sensory.difficultyAtNight} />Difficulty seeing at night<br />
            <Checkbox field='sensory.rightEyePain' initialValue={sensory.rightEyePain} />Right eye pain<br />
            <Checkbox field='sensory.leftEyePain' initialValue={sensory.leftEyePain} />Left eye pain<br />
            <Checkbox field='sensory.bilateralEyePain' initialValue={sensory.bilateralEyePain} />Bilateral eye pain<br />
            <Checkbox field='sensory.blurredVision' initialValue={sensory.blurredVision} />Blurred vision<br />
            <Checkbox field='sensory.halosVision' initialValue={sensory.halosVision} />Halos in vision<br />
            <Checkbox field='sensory.blindSpots' initialValue={sensory.blindSpots} />Blind spots<br />
            <Checkbox field='sensory.legalBlind' initialValue={sensory.legalBlind} />Legal blindness<br />
            <Checkbox field='sensory.blindnessLeft' initialValue={sensory.blindnessLeft} />Blindness in left eye<br />
            <Checkbox field='sensory.blindnessRight' initialValue={sensory.blindnessRight} />Blindness in right eye<br />
            <Checkbox field='sensory.prosthesisLeft' initialValue={sensory.prosthesisLeft} />Prosthesis, left orbit<br />
            <Checkbox field='sensory.prosthesisRight' initialValue={sensory.prosthesisRight} />Prosthesis, right orbit<br />
            <Checkbox field='sensory.enuclearLeft' initialValue={sensory.enuclearLeft} />Enuclear, left orbit<br />
            <Checkbox field='sensory.enuclearRight' initialValue={sensory.enuclearRight} />Enuclear, right orbit
          </div>
          <div className={styles.section}>
            <Checkbox field='sensory.wearsGlasses' initialValue={sensory.wearsGlasses} />Wears glasses<br />
            <Checkbox field='sensory.wearsContacts' initialValue={sensory.wearsContacts} />Wears contacts
          </div>
          <div className={styles.section}>
            <SecondaryText>Vision notes:</SecondaryText><br />
            <TextArea field='sensory.visionNotes' initialValue={sensory.visionNotes} />
          </div>
          <PrimaryText>Hearing Assessment</PrimaryText><br />
          <div className={styles.section}>
            <Checkbox field='sensory.noHearingProblems' initialValue={sensory.noHearingProblems} />No hearing problems noted
          </div>
          <div className={styles.section}>
            <SecondaryText>Mark all that apply:</SecondaryText><br />
            <Checkbox field='sensory.hearingWorsening' initialValue={sensory.hearingWorsening} />Hearing problems worsening<br />
            <Checkbox field='sensory.difficultHearing' initialValue={sensory.difficultHearing} />Difficulty hearing<br />
            <Checkbox field='sensory.hearingAidRight' initialValue={sensory.hearingAidRight} />Hearing aid, right ear<br />
            <Checkbox field='sensory.hearingAidLeft' initialValue={sensory.hearingAidLeft} />Hearing aid, left ear<br />
            <Checkbox field='sensory.implantRight' initialValue={sensory.implantRight} />Cochlear implant, right ear<br />
            <Checkbox field='sensory.implantLeft' initialValue={sensory.implantLeft} />Cochlear implant, left ear<br />
            <Checkbox field='sensory.refusesHearingAid' initialValue={sensory.refusesHearingAid} />Needs hearing aid but refuses<br />
            <Checkbox field='sensory.deaf' initialValue={sensory.deaf} />Deaf
          </div>
          <div className={styles.section}>
            <SecondaryText>Hearing notes:</SecondaryText><br />
            <TextArea field='sensory.hearingNotes' initialValue={sensory.hearingNotes} />
          </div>
          <PrimaryText>Pupils</PrimaryText><br />
          <Button onClick={this.props.resetPupilsRadios}>Clear Radios</Button><br />
          <PrimaryText>Pupillary Equality</PrimaryText><br />
          <div className={styles.section}>
            <SecondaryText>Bilateral assessment:</SecondaryText><br />
            <table>
              <tbody className={styles.topAlign}>
                <tr>
                  <td><SecondaryText>Equal?</SecondaryText></td>
                  <td>
                    <RadioGroup field='sensory.pupilEqual' initialValue={sensory.pupilEqual}>
                      <Radio value='yes' />Yes<br />
                      <Radio value='no' />No
                    </RadioGroup>
                  </td>
                </tr>
                <tr>
                  <td><SecondaryText>Round?</SecondaryText></td>
                  <td>
                    <RadioGroup field='sensory.pupilRound' initialValue={sensory.pupilRound}>
                      <Radio value='yes' />Yes<br />
                      <Radio value='no' />No
                    </RadioGroup>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <PrimaryText>Size</PrimaryText><br />
          <div className={styles.section}>
            <table>
              <tbody>
                <tr>
                  <td><SecondaryText>Left pupil:</SecondaryText></td>
                  <td><NumericText field='sensory.pupilLeftSize' initialValue={sensory.pupilLeftSize} size={4} /></td>
                  <td> mm</td>
                </tr>
                <tr>
                  <td><SecondaryText>Right pupil:</SecondaryText></td>
                  <td><NumericText field='sensory.pupilRightSize' initialValue={sensory.pupilRightSize} size={4} /></td>
                  <td> mm</td>
                </tr>
              </tbody>
            </table>
          </div>
          <PrimaryText>Pupillary Reaction</PrimaryText><br />
          <div className={styles.section}>
            <SecondaryText>Left eye reaction to light:</SecondaryText><br />
            <RadioGroup field='sensory.leftEyeReaction' initialValue={sensory.leftEyeReaction}>
              <Radio value='brisk' />Brisk<br />
              <Radio value='sluggish' />Sluggish<br />
              <Radio value='no response' />No response<br />
              <Radio value='blown' />Blown
            </RadioGroup>
            <br />
            <br />
            <Checkbox field='sensory.leftEyeConst' initialValue={sensory.leftEyeConst} />Constricted<br />
            <Checkbox field='sensory.leftEyeDilate' initialValue={sensory.leftEyeDilate} />Dilated
          </div>
          <div className={styles.section}>
            <SecondaryText>Right eye reaction to light:</SecondaryText><br />
            <RadioGroup field='sensory.rightEyeReaction' initialValue={sensory.rightEyeReaction}>
              <Radio value='brisk' />Brisk<br />
              <Radio value='sluggish' />Sluggish<br />
              <Radio value='no response' />No response<br />
              <Radio value='blown' />Blown
            </RadioGroup>
            <br />
            <br />
            <Checkbox field='sensory.rightEyeConst' initialValue={sensory.rightEyeConst} />Constricted<br />
            <Checkbox field='sensory.rightEyeDilate' initialValue={sensory.rightEyeDilate} />Dilated
          </div>
          <PrimaryText>Pupillary Accommodation</PrimaryText><br />
          <div className={styles.section}>
            Positive evaluation requires two findings: bilateral pupillary constriction and convergency of axis of eyes.<br />
            <SecondaryText>Accommodation present?</SecondaryText><br />
            <RadioGroup field='sensory.accommodation' initialValue={sensory.accommodation}>
              <Radio value='yes' />Yes<br />
              <Radio value='no' />No
            </RadioGroup>
          </div>
          <div className={styles.section}>
            <SecondaryText>Pupil notes:</SecondaryText><br />
            <TextArea field='sensory.pupilNotes' initialValue={sensory.pupilNotes} />
          </div>
        </div>
      </ContentBox>
    );
  }
}

export default EditSensory;



// WEBPACK FOOTER //
// ./client/src/components/patientPages/progressNote/edit/EditSensory.jsx